import React from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
interface CommentFormProps {
  comment: string;
  setComment: (comment: string) => void;
  handleCommentSubmit: (e: React.FormEvent) => void;
  user: any | null;
}
const CommentForm: React.FC<CommentFormProps> = ({
  comment,
  setComment,
  handleCommentSubmit,
  user
}) => {
  return <form onSubmit={handleCommentSubmit} className="mb-8">
      <Textarea value={comment} onChange={e => setComment(e.target.value)} placeholder={user ? "Share your thoughts..." : "Login to comment"} disabled={!user} className="mb-4 min-h-[100px]" />
      <Button type="submit" disabled={!user} className="ml-auto bg-emerald-400 hover:bg-emerald-300">
        Post Comment
      </Button>
    </form>;
};
export default CommentForm;